<template>
    <div>
        <v-dialog v-model="deleteDialog" max-width="500">
          <v-card class="pa-2 py-3">
            <v-card-title class="text-h6 font-weight-600">
              <span class="secondary--font"> Delete Tag </span>
            </v-card-title>
            <v-card-text class="body-2">
              Are you sure you want to delete the tag ({{
                name | upperCaseFirst
              }})
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                id="cancel-delete"
                text
                @click="deleteDialog = false"
                class="font-weight-bold"
              >
                Cancel
              </v-btn>
              <v-btn
                id="confirm-delete"
                dark
                @click="confirmDelete()"
                :loading="loading"
                class="font-weight-bold"
              >
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </div>
  </template>
  <script>
  import { $tag } from "@/services/Index";
  
  export default {
    name: "reply-template-index",
    props:{
        name:{
            type: String,
        },
        id:{
            type: Number,
        }
    },
    
    data: () => {
      return {
        selectedData: [],
        loading: false,
        deleteDialog: false,
      };
    },

    methods:{
      async confirmDelete() {
        this.loading = true;
        let payload = {
          id: this.id,
        };
        try {
          const response = await $tag.delete(payload, {});
          if (response.data) {
            this.deleteDialog = false;
            this.$emit('getTag');
            this.$store.dispatch("ui/snackbar", [
              {
                title: "Delete Tag",
                message: `Selected tag has been deleted.`,
                type: "success",
              },
            ]);
          }
        } catch (error) {
          this.deleteDialog = false;
        } finally {
          this.loading = false;
        }
      },
    },
  };
  </script>